// extracted by mini-css-extract-plugin
export default {"facility-card":"FacilitiesCard_facility-card__DdfwV","facility-title":"FacilitiesCard_facility-title__4Q-9G","facility-description":"FacilitiesCard_facility-description__x8anM"};